import { render, staticRenderFns } from "./SelezionaNumero.vue?vue&type=template&id=425ebb7c&scoped=true&lang=pug"
import script from "./SelezionaNumero.vue?vue&type=script&lang=ts"
export * from "./SelezionaNumero.vue?vue&type=script&lang=ts"
import style0 from "./SelezionaNumero.vue?vue&type=style&index=0&id=425ebb7c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ebb7c",
  null
  
)

export default component.exports